import { render, staticRenderFns } from "./AllProducts.vue?vue&type=template&id=32ce805f&scoped=true&"
import script from "./AllProducts.vue?vue&type=script&lang=js&"
export * from "./AllProducts.vue?vue&type=script&lang=js&"
import style0 from "./AllProducts.vue?vue&type=style&index=0&id=32ce805f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce805f",
  null
  
)

export default component.exports